import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button as Button$1 } from '../../Button/index.js';
import Dropdown from 'react-bootstrap/Dropdown';
import { MenuButton } from '@chakra-ui/react';
import { tokens } from '@everfi/design-system';
import { CardFooter } from '../../../core/components/Card/card-footer.js';
import { Label } from '../../../core/components/Label/component.js';
import { FAIcon } from '../../fa-icon/component.js';
import { Layout } from '../../../core/components/Layout/component.js';
import { DropdownMenu } from '../../../core/components/DropdownMenu/component.js';
import Button from '../../../core/components/Button/component.js';
var _excluded = ["action", "items", "icon", "style", "rightIcon", "rightIconProps"];

var CardActionBox = function CardActionBox(props) {
  var buttons = props.buttons,
      _props$chakra = props.chakra,
      chakra = _props$chakra === void 0 ? 'on' : _props$chakra,
      className = props.className,
      onClick = props.onClick;

  if (buttons.length <= 0) {
    return null;
  }

  var createButton = function createButton() {
    return buttons === null || buttons === void 0 ? void 0 : buttons.map(function (config, index) {
      var action = config.action,
          items = config.items,
          icon = config.icon,
          style = config.style,
          rightIcon = config.rightIcon,
          rightIconProps = config.rightIconProps,
          rest = _objectWithoutProperties(config, _excluded);

      if (items !== null && items !== void 0 && items.length) {
        var _config$items;

        return chakra === 'on' ? /*#__PURE__*/React.createElement(DropdownMenu, {
          items: items.map(function (item) {
            return {
              text: item.label,
              onClick: item.action
            };
          }),
          menuButton: /*#__PURE__*/React.createElement(Button, {
            as: MenuButton,
            key: "action-button-".concat(index),
            variant: style
          }, rightIcon && config.label ? /*#__PURE__*/React.createElement(Label, {
            label: {
              type: 'iconRight',
              options: {
                text: config.label,
                icon: {
                  iconName: rightIcon || ''
                }
              }
            }
          }) : config.label)
        }) : /*#__PURE__*/React.createElement(Dropdown, {
          "data-type": "dropdown",
          key: "action-button-".concat(index)
        }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
          variant: style,
          className: "ui-default btn btn-".concat(style)
        }, config.label, rightIcon && /*#__PURE__*/React.createElement(FAIcon, _extends({
          icon: rightIcon,
          additionalClasses: "right"
        }, rightIconProps))), /*#__PURE__*/React.createElement(Dropdown.Menu, null, (_config$items = config.items) === null || _config$items === void 0 ? void 0 : _config$items.map(function (item, idx) {
          return /*#__PURE__*/React.createElement(Dropdown.Item, {
            key: idx,
            onClick: item.action
          }, item.label);
        })));
      } else {
        return /*#__PURE__*/React.createElement(Button$1, _extends({}, rest, {
          renderAsLegacy: chakra === 'off',
          style: style,
          icon: icon,
          rightIcon: rightIcon,
          rightIconProps: rightIconProps,
          key: "action-button-".concat(index),
          onClick: action
        }));
      }
    });
  };

  return chakra === 'on' ? /*#__PURE__*/React.createElement("div", {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(CardFooter, null, /*#__PURE__*/React.createElement(Layout, {
    variant: "flex",
    alignItems: "center",
    columnGap: tokens.SpacingBaseSm
  }, createButton()))) : /*#__PURE__*/React.createElement("div", {
    className: className,
    onClick: onClick
  }, createButton());
};

CardActionBox.displayName = 'CardActionBox';
export { CardActionBox };